export default "/images/vendor/@coreui/icons/svg/flag/cif-lv.svg?2170e5fd49e11caf179c322ffe0406b3";